import { publicRequest, BASE_URL } from "../requestMethods";

import {
  fetchCategoryStart,
  fetchCategorySuccess,
  fetchCategoryFailure,
} from "../redux/categoryRedux";

export const fetchCategories = async (dispatch) => {
  dispatch(fetchCategoryStart());
  try {
    const res = await publicRequest.get(
      `${BASE_URL}categories/getCategoryForUsers`
    );
    // console.log(res.data, "fetch cat");
    dispatch(fetchCategorySuccess(res.data));
  } catch (err) {
    dispatch(fetchCategoryFailure());
  }
};

export const getCategoryData = async (id) => {
  return await publicRequest.get(`${BASE_URL}categories/findCategory/${id}`)
}

export const getSubCategoryByCategory = async (id) => {
  return await publicRequest.get(`${BASE_URL}categories/subcategories/${id}`);
};


export const getProductByCategory = async (id) => {
  return await publicRequest.get(`${BASE_URL}products/findByCategory/${id}`);
};
